module.exports = __webpack_public_path__ + "img/meta-icon.de8e232f.svg";